export function buildImCsReportParams(filters = {}) {
  const params = {};
  if (filters.startDateInput) {
    params.start = filters.startDateInput;
  }
  if (filters.endDateInput) {
    params.end = filters.endDateInput;
  }
  if (filters.agentAdminId?.trim()) {
    params.agentAdminId = filters.agentAdminId.trim();
  }
  return params;
}

export function formatDurationMs(ms) {
  if (ms == null || ms === '') {
    return '—';
  }
  const n = Number(ms);
  if (!Number.isFinite(n) || n < 0) {
    return '—';
  }
  if (n < 1000) {
    return `${Math.round(n)}ms`;
  }
  const totalSec = Math.floor(n / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  if (h > 0) {
    return `${h}h ${m}m ${s}s`;
  }
  if (m > 0) {
    return `${m}m ${s}s`;
  }
  return `${s}s`;
}

export function formatRatio(ratio) {
  if (ratio == null || ratio === '') {
    return '—';
  }
  const n = Number(ratio);
  if (!Number.isFinite(n)) {
    return '—';
  }
  return `${(n * 100).toFixed(1)}%`;
}
